import React from "react";
import { Box, TextField } from "@mui/material";
import OfferedDepositsTable from "./OfferedDepositsTable";
import GuarantorsTable from "./GuarantorsTable";
import SectionHeader from "./SectionHeader";

const DepositsTab = ({ data, onUpdate }) => {
  const updateField = (path, value) => {
    onUpdate(path, value);
  };

  return (
    <Box>
      {/* Section: Offered Deposits */}
      <Box sx={{ marginBottom: "32px" }}>
        <Box sx={{ marginTop: "24px", marginBottom: "24px" }}>
          <OfferedDepositsTable
            data={data.deposits?.offeredDeposits || []}
            onChange={(newData) => updateField("deposits.offeredDeposits", newData)}
          />
        </Box>

        <Box sx={{ marginTop: "16px" }}>
          <Box sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#1A1E24",
            marginBottom: "8px"
          }}>
            Предлагаемые залоговые коэффициенты:
          </Box>
          <TextField
            value={data.deposits?.suggestedCoeff || ""}
            onChange={(e) => updateField("deposits.suggestedCoeff", e.target.value)}
            multiline
            rows={3}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "14px",
              },
            }}
          />
        </Box>
      </Box>

      {/* Section: Guarantors */}
      <Box sx={{ marginBottom: "32px" }}>
        <GuarantorsTable
          data={data.deposits?.guarantors || []}
          onChange={(newData) => updateField("deposits.guarantors", newData)}
        />
      </Box>
    </Box>
  );
};

export default DepositsTab;
